import {Theme} from "@emotion/react";
import {translate} from "@util";
import {Pagination, Stack, SxProps, Typography} from "@mui/material";
import {GridSlotProps} from "@mui/x-data-grid";
import {Select} from "./Select";
import {useDownBreakpoint} from "@hooks";

type Props = {
  sx?: SxProps<Theme>;
};

export const DEF_ROWS_PER_PAGE = 20;
const ROWS_PER_PAGE_OPTIONS = [20, 50, 100];

const Paginator = (props: Props & GridSlotProps["basePagination"]) => {
  const {
    sx,
    page,
    rowsPerPage,
    count,
    disabled,
    onPageChange,
    onRowsPerPageChange,
  } = props;

  const downSm = useDownBreakpoint("sm");

  const numberOfPages = rowsPerPage > 0 ? Math.ceil(count / rowsPerPage) : 0;

  // Una sola pagina e nessuna opzione di righe per pagina che la cambierebbe
  if (count <= Math.min(rowsPerPage, ROWS_PER_PAGE_OPTIONS[0])) {
    return null;
  }

  return (
    <Stack
      sx={{...sx}}
      flex={1}
      direction="row"
      alignItems="center"
      justifyContent={"center"}
      gap={2}
      height={downSm ? 48 : 64}
      maxHeight={downSm ? 48 : 64}>
      {!downSm && onRowsPerPageChange && (
        <>
          <Typography variant="body2" color="text.secondary">
            {translate("paginator.rowsPerPage")}
          </Typography>
          <Select<number>
            value={rowsPerPage}
            onChange={onRowsPerPageChange}
            options={ROWS_PER_PAGE_OPTIONS.map(value => ({
              label: value.toString(),
              value,
            }))}
          />
        </>
      )}
      <Pagination
        size={"small"}
        showFirstButton
        showLastButton
        color="primary"
        disabled={disabled}
        count={numberOfPages}
        page={page + 1}
        onChange={(_e, p) => onPageChange(null, p - 1)}
      />
    </Stack>
  );
};

export {Paginator};
